export default "__VITE_ASSET__30fe1991__"